import { useCallback } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import DescriptionIcon from '@/assets/icons/icon-description.svg'
import PersonIcon from '@/assets/icons/icon-person.svg'
import { ChatTag } from '@/models/chattingUI/messageEditor/tags/types'
import { CreatorAvatar } from '@/modules/creators/ui/CreatorAvatar.tsx'
import { isGuestType, isUserType } from '@/utils/releaseForms'

interface Props {
  item: ChatTag
  onRemove: (tagId: number) => void
}

export const ChatTagItem = ({ item, onRemove }: Props) => {
  const handleRemove = useCallback(() => {
    onRemove(item.id)
  }, [item, onRemove])

  const type = item.type ?? ''

  return (
    <div className="dark:bg-primary-900 flex h-7 shrink-0 items-center rounded-2xl p-1 pr-2">
      {isUserType(type) ? (
        <CreatorAvatar
          name={item.name}
          avatarSrc={'user' in item ? item.user?.avatar : null}
          size={20}
          className="mr-2"
        />
      ) : isGuestType(type) ? (
        <PersonIcon className="mr-2 h-5 w-5" />
      ) : (
        <DescriptionIcon className="mr-2 h-5 w-5" />
      )}
      <span className="mr-2 text-sm font-medium">{item.name}</span>
      <CloseIcon
        onClick={handleRemove}
        className="hover:text-primary-500 cursor-pointer transition"
      />
    </div>
  )
}
